module.exports = __webpack_public_path__ + "static/media/warning-icon.3c7d9ece.svg";